import { createContext, useContext, useState, ReactNode } from "react";
import { trackEvent } from "@/lib/analytics";

interface ScheduleContextType {
  open: boolean;
  openDialog: () => void;
  closeDialog: () => void;
  setOpen: (open: boolean) => void;
}

const ScheduleContext = createContext<ScheduleContextType | undefined>(undefined);

export const ScheduleProvider = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false);

  return (
    <ScheduleContext.Provider
      value={{
        open,
        openDialog: () => {
          trackEvent("schedule_open");
          setOpen(true);
        },
        closeDialog: () => setOpen(false),
        setOpen,
      }}
    >
      {children}
    </ScheduleContext.Provider>
  );
};

export const useSchedule = () => {
  const ctx = useContext(ScheduleContext);
  if (!ctx) throw new Error("useSchedule must be used within ScheduleProvider");
  return ctx;
};
